import type { FC, ReactNode } from "react";

const TOOLS = [
  { href: "/", label: "Publish" },
  { href: "/entity-links", label: "Entity Links" },
  { href: "/entity-groups", label: "Project Groups" },
  { href: "/extractinator", label: "Extractinator" },
  { href: "/data-checks", label: "Data Checks" },
];

export const ToolsHeader: FC<{ children?: ReactNode }> = ({ children }) => {
  const current = window.location.pathname;
  const title = TOOLS.find((t) => t.href === current)?.label ?? "Tools";

  return (
    <div className="mb-4 flex items-center gap-2 rounded-xl bg-white/70 px-4 py-2 backdrop-blur-sm">
      <h1 className="text-2xl font-bold"> &nbsp; 🧰 &nbsp; {title} &nbsp; </h1>
      {TOOLS.filter((t) => t.href !== current).map((t) => (
        <a
          key={t.href}
          href={t.href}
          className="flex h-6 items-center rounded bg-amber-500 px-2 text-xs font-semibold text-white transition-colors hover:bg-amber-600"
        >
          {t.label}
        </a>
      ))}
      {children}
    </div>
  );
};
